<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <div class="mb-3">
      <div class="row">
        <div class="col-11"><h4>Personas</h4></div>
        <div class="col-1">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true" aria-label="Abrir ayuda de personas">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Personas">
      <AyudaPersona />
    </Modal>

    <hr>
<DataTable
  :data="personas"
  :columns="columns"
  idField="idPersona"
  :mostrarBotonTodos="true"
  :mostrarBotonNuevo="true"
  :mostrarBotonExcel="true"
  :mostrarInfo="false"
  :mostrarEditar="true"
  :mostrarVer="true"
  :mostrarEliminar="false"
  @refresh="getDataTodos()"
  @create="abrirModalCrear"
  @edit="row => abrirModalEditar(row.idPersona)"
  @view="row => abrirEditar(row.idPersona)"
  @delete="row => deletePersona(row.idPersona)"
>
  <template #acciones-fila="{ row }">
    <TableActionBtn icon="event"         variant="success" title="Nueva Cita"          @click="crearCita(row.idPersona)" />
    <TableActionBtn icon="notifications" variant="info"    title="Nueva Notificación"  @click="crearNotificacion(row.idPersona)" />
  </template>
</DataTable>

    <!-- Modal Persona -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">

              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">IdPersona</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.idPersona" disabled>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Tipo Id.</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.idTipoIden">
                      <option v-for="t in tipoIdens" :value="t.idTipoIden" :key="t.idTipoIden">{{ t.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="col-form-label">Documento</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.documento"
                      style="text-transform:uppercase">
                  </div>
                  <div class="col-2"><label class="col-form-label">Estado Civil</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.idEstadoCivil">
                      <option v-for="e in estadoCivils" :value="e.idEstadoCivil" :key="e.idEstadoCivil">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Fecha Nac.</label></div>
                  <div class="col-2">
                    <input type="date" class="form-control" v-model="datoPersona.fechaNac">
                  </div>
                  <div class="col-2"><label class="col-form-label">Sexo</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.sexo">
                      <option value="">Seleccione el género</option>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="col-form-label">Teléfono</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.telefono"
                      style="text-transform:uppercase">
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Primer Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerNombre"
                      style="text-transform:uppercase">
                  </div>
                  <div class="col-2"><label class="col-form-label">Segundo Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoNombre"
                      style="text-transform:uppercase">
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Primer Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerApellido"
                      style="text-transform:uppercase">
                  </div>
                  <div class="col-2"><label class="col-form-label">Segundo Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoApellido"
                      style="text-transform:uppercase">
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Localidad</label></div>
                  <div class="col-4">
                    <select class="form-select" v-model="datoPersona.idLocalidad">
                      <option v-for="l in localidads" :value="l.idLocalidad" :key="l.idLocalidad">{{ l.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="col-form-label">Email</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.email">
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Dirección</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.direccion"
                      style="text-transform:uppercase">
                  </div>
                </div>
              </div>

              <button type="button" class="btn btn-link p-0 text-decoration-none"
                @click="mostrarBloque = !mostrarBloque">
                {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
              </button>
              <div v-if="mostrarBloque" class="mb-3 mt-2">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">FechaReg</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.fechaReg" disabled>
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button v-if="btnCrear" type="button" class="btn btn-success d-flex align-items-center gap-1"
              @click="guardarPersona" title="Guardar">
              <span class="material-symbols-outlined">save</span> Guardar
            </button>
            <button v-if="btnEditar" type="button" class="btn btn-success d-flex align-items-center gap-1"
              @click="guardarEditPersona" title="Actualizar">
              <span class="material-symbols-outlined">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout       from '@/components/Layout.vue'
import Footer       from '@/components/Footer.vue'
import DataTable    from '@/components/DataTable.vue'
import TableActionBtn from "@/components/TableActionBtn.vue";
import AyudaPersona from '@/views/ayuda/AyudaPersona.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat   from '@/modules/dateFormat.js'
import api          from '@/services/api'
import { Modal }    from 'bootstrap'
import swal         from 'sweetalert'

export default {
  components: { Layout, Footer, AyudaPersona, DataTable, TableActionBtn },
  data() {
    return {
      personas:      [],
      datoPersona:   {},
      titulo:        '',
      btnCrear:      false,
      btnEditar:     false,
      modalWindow:   true,
      tipoIdens:     [],
      localidads:    [],
      estadoCivils:  [],
      mostrarBloque: false,
      showModalHelp: false,
      columns: [
        { field: 'documento',      label: 'Documento' },
        { field: 'nombreCompleto', label: 'Nombre' },
        { field: 'telefono',       label: 'Teléfono' },
        { field: 'email',          label: 'E-mail' },
      ],
    }
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.getDataTodos()
    this.fetchTipoIdens()
    this.fetchLocalidads()
    this.fetchEstadoCivils()
  },
  methods: {
    getFormattedDate(date) { return dateFormat.getFormattedDate(date) },

    // Helper modal
    getModalInstance() {
      const el = document.getElementById('ventanaModal')
      return el ? Modal.getInstance(el) ?? new Modal(el) : null
    },

    // Carga de datos
    getDataTodos() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get(`/vwpersonas/idempresa/${idEmpresa}`)
        .then(r => { this.personas = r.data.reverse() })
        .catch(err => console.error('Error al obtener personas:', err))
    },

    // Validación
    validarFormLocal() {
      const fields = ['idTipoIden','idLocalidad','idEstadoCivil','documento',
        'primerNombre','segundoNombre','primerApellido','segundoApellido',
        'fechaNac','direccion','telefono','sexo','email']
      return validarForm(this.datoPersona, fields, fields)
    },

    // CRUD
    async guardarPersona() {
      if (this.validarFormLocal() !== 1) return
      try {
        this.datoPersona.idEmpresa   = window.sessionStorage.getItem('idEmpresa')
        this.datoPersona.tipoPersona = 'N'
        await api.post('/personas', this.datoPersona)
        this.getModalInstance()?.hide()
        swal('Correcto!', 'Persona creada exitosamente!', 'success')
        this.getDataTodos()
      } catch { swal('Error!', 'Inténtelo de nuevo!', 'error') }
    },
    async guardarEditPersona() {
      if (this.validarFormLocal() !== 1) return
      try {
        await api.post('/personas', this.datoPersona)
        this.getModalInstance()?.hide()
        swal('Correcto!', 'Persona actualizada exitosamente!', 'success')
        this.getDataTodos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },
    abrirModalCrear() {
      this.datoPersona = {}
      this.titulo      = 'Crear Persona'
      this.btnCrear    = true
      this.btnEditar   = false
      this.$nextTick(() => this.getModalInstance()?.show())
    },
    abrirModalEditar(idPersona) {
      this.titulo    = 'Editar Persona'
      this.btnCrear  = false
      this.btnEditar = true
      if (idPersona) api.get(`/vwpersonas/${idPersona}`).then(r => { this.datoPersona = r.data })
      this.$nextTick(() => this.getModalInstance()?.show())
    },
abrirEditar(idPersona) {
  if (idPersona) {
    this.$router.push({
      name: 'PersonaForm',
      state: {
        pagina:    'P',
        idPersona: idPersona,
      }
    });
  }
},
    crearCita(idPersona) {
      if (idPersona) {  
        this.$router.push({
          name: 'PacienteCita02',
          state: {
            idPersona:      idPersona,
            idEspecialidad: 0,
            idMedico:       0,
          }
        });
      }
    },
crearNotificacion(idPersona) {
  if (idPersona) {
    this.$router.push({
      name: 'Persona_MedioPers',
      state: {
        idPersona: idPersona,
      }
    });
  }
},	
    async deletePersona(idPersona) {
      const ok = await swal({ title: '¿Eliminar persona?', icon: 'warning',
        buttons: true, dangerMode: true })
      if (!ok) return
      try {
        await api.delete(`/personas/${idPersona}`)
        this.getDataTodos()
      } catch { swal('Error!', 'No se pudo eliminar.', 'error') }
    },

    // Catálogos
    fetchTipoIdens()   { api.get('/vwtipoidens').then(r    => { this.tipoIdens    = r.data }) },
    fetchLocalidads()  { api.get('/vwlocalidads').then(r   => { this.localidads   = r.data }) },
    fetchEstadoCivils(){ api.get('/vwestadocivils').then(r => { this.estadoCivils = r.data }) },
  },
}
</script>

<style src="@/assets/css/tablaHover.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<!--
<style src="@/assets/css/listaFiltrada.css" scoped></style>
-->